<!--tab-->
<template>
  <div class="data-card-tab">
    <template v-for="(item,index) in tabList">
      <div :id="name+index" :key="index" :class="['data-card-tab-item',{'data-card-tab-active':curIndex==index}]"
        @click="onSwitchTab(index,item.code)">{{item.name}}</div>
      <div class="data-card-tab-space" id="tab-space" :key="index+'space'">
         <div class="notice-contain">
         <div class="notice-num" v-if="item.quantity > 0 && item.quantity < 100">{{item.quantity}}</div>
          <div class="notice-num" v-if="item.quantity > 99">99+</div>
          </div>
      </div>

    </template>

    <div ref="line" class="data-card-tab-line"
      :style="'width:'+width+'px;transform:translateX('+left+'px);transition-duration: 0.3s;height:2px;'"></div>
  </div>
</template>

<script>
    export default {
        components: {},
        props: {
            // 数据
            tabList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            name: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                curIndex: 0,
                width: 0,
                left: 0
            };
        },
        computed: {},
        methods: {
            onSwitchTab (idx, code) {
                this.switchTab(idx);
                this.$emit('onSwitch', code);
            },
            switchTab (index) {
                this.curIndex = index;
                let length = 0;
                for (let i = 0; i < this.tabList.length; i++) {
                    let tabDiv = document.querySelector('#' + this.name + i);
                    if (i < index) {
                        length +=
                            tabDiv.offsetWidth +
                            document.querySelector('#tab-space').offsetWidth
                    } else if (i === index) {
                        this.width = tabDiv.offsetWidth;
                    }
                }
                this.left = length;
            }
        },
        mounted () {
            this.switchTab(0);
        }
    };
</script>

<style scoped lang="less">
  .data-card-tab {
    position: relative;
    overflow-x: scroll;
    white-space: nowrap;
    // display: flex;
    // align-items: center;
    /*不换行*/
    height: 50px;

    &-item {
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
      text-align: left;

    }

    &-space {
      display: inline-block;
      width: 26px;
      .notice-contain{
          position: relative;
          .items-img {
            width: 40px;
            height: 40px;
            margin-bottom: 8px;
          }

          .notice-num{
            background: #ff4d4d;
            // display: flex;
            // align-items: center;
            // justify-content: center;

            border-radius: 8px;
            height: 15px;
            padding: 0 4px;
            font-size:8px;
            line-height:15px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(255,255,255,1);
            position: absolute;
            top: -13px;
            left: 0px;
            z-index: 10;
            border: 1px solid #ffffff;
            min-width: 15px;
          }
        }
    }

    &-active {
      color: rgba(54, 179, 116, 1);
      font-weight: 700;
    }

    &-line {
      position: absolute;
      bottom: 12px;
      left: 0;
      width: 56px;
      height: 2px;
      background: rgba(54, 179, 116, 1);
    }
  }

  .data-card-tab::-webkit-scrollbar {
    display: none;
  }
</style>
